import React, { useState } from "react";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import PropTypes from "prop-types";
import ReactPlayer from "react-player";
import { env } from "@bkry/bowline-utils";
const { REACT_APP_CDN_PATH } = env;
const ArtMintTabs = (
  { selectedArtist, setSelectedArtist, metaData },
  context
) => {
  const toggleTab = (tab) => {
    if (selectedArtist !== tab) setSelectedArtist(tab);
  };
  const [showModal, setShowModal] = useState(false);
  const hideModal = () => setShowModal(false);
  const displayModal = (image) => setShowModal(image);

  const renderAmount = (artist, artwork) => {
    const maxSupply = metaData?.[artist]?.[artwork]?.max_supply;
    const mintedSupply = metaData?.[artist]?.[artwork]?.minted_supply;
    return (
      <>
        {maxSupply && (
          <div className="text-center my-2 small">
            {mintedSupply} / {maxSupply === "Open Edition" ? "∞" : maxSupply}{" "}
            {context.t("minted")}
          </div>
        )}
      </>
    );
  };

  const renderModal = () => {
    let artist = null;
    let artwork = null;
    if (typeof showModal === "string" && showModal.length > 0) {
      [artist, artwork] = showModal.split("-");
    }
    const animationUrl =
      artist &&
      artwork &&
      `https://metadata.bowline.app/0xsamsungmx1/assets/web/${artist}-${artwork}.mp4`;
    return (
      <Modal
        isOpen={showModal ? true : false}
        toggle={hideModal}
        fullscreen="lg"
      >
        <ModalHeader toggle={hideModal}>
          {renderAmount(artist, artwork)}
        </ModalHeader>
        <ModalBody>
          {artist === "artist_2" ? (
            <img
              src={
                (REACT_APP_CDN_PATH || "") +
                `/images/ArtMintTabs/${showModal}.png`
              }
              alt="artist"
              className="img-fluid w-100"
            />
          ) : (
            <div>
              <ReactPlayer
                width="100%"
                height="auto"
                url={animationUrl}
                controls={true}
                loop={true}
                muted={true}
                playing={true}
                playsinline
                config={{
                  file: {
                    attributes: {
                      controlsList: "nodownload noplaybackrate",
                      disablePictureInPicture: true,
                    },
                  },
                }}
              />
            </div>
          )}
        </ModalBody>
      </Modal>
    );
  };

  return (
    <Row className="d-flex justify-content-between">
      <span className="text-center pb-4 h3">
        {selectedArtist === "0" && <>{context.t("Choose your Artist")}</>}
        {selectedArtist === "1" && <>{context.t("Antoni Tudisco")}</>}
        {selectedArtist === "2" && <>{context.t("Bruno Urli")}</>}
        {selectedArtist === "3" && (
          <>{context.t("Charlotte Taylor & Anthony Authié")}</>
        )}
      </span>

      <Nav tabs className="d-flex justify-content-center border-bottom-0">
        <NavItem className="mx-2 my-2 my-xxl-0">
          <NavLink
            className={
              selectedArtist === "1"
                ? "active text-white bg-secondary btn-outline-primary border rounded-pill"
                : "cursor-pointer btn-outline-primary border rounded-pill"
            }
            onClick={() => toggleTab("1")}
          >
            <span className="ms-1">{context.t("Antoni Tudisco")}</span>
          </NavLink>
        </NavItem>
        <NavItem className="mx-2 my-2 my-xxl-0">
          <NavLink
            className={
              selectedArtist === "2"
                ? "active text-white bg-secondary btn-outline-primary border rounded-pill"
                : "cursor-pointer btn-outline-primary border rounded-pill"
            }
            onClick={() => toggleTab("2")}
          >
            <span className="ms-1">{context.t("Bruno Urli")}</span>
          </NavLink>
        </NavItem>
        <NavItem className="mx-2 my-2 my-xxl-0">
          <NavLink
            className={
              selectedArtist === "3"
                ? "active text-white bg-secondary btn-outline-primary border rounded-pill"
                : "cursor-pointer btn-outline-primary border rounded-pill"
            }
            onClick={() => toggleTab("3")}
          >
            <span className="ms-1">
              {context.t("Charlotte Taylor & Anthony Authié")}
            </span>
          </NavLink>
        </NavItem>
      </Nav>
      {renderModal()}
      <TabContent activeTab={selectedArtist} className="mb-3 mt-5">
        {selectedArtist === "0" && (
          <Row>
            <Col xs={12}>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/ArtMintTabs/640x650_Mint_prev-ALL_ARTISTS.png"
                }
                alt="artist"
                className="img-fluid w-100"
              />
            </Col>
          </Row>
        )}
        <TabPane tabId="1">
          <Row className="g-0">
            <Col>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/ArtMintTabs/artist_1-artwork_1-stripe.png"
                }
                alt="artist"
                height="auto"
                width="100%"
                onClick={() => displayModal("artist_1-artwork_1")}
                className="artminttabs_stripeimage"
              />
              {renderAmount("artist_1", "artwork_1")}
            </Col>
            <Col>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/ArtMintTabs/artist_1-artwork_2-stripe.png"
                }
                alt="artist"
                height="auto"
                width="100%"
                onClick={() => displayModal("artist_1-artwork_2")}
                className="artminttabs_stripeimage"
              />
              {renderAmount("artist_1", "artwork_2")}
            </Col>
            <Col>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/ArtMintTabs/artist_1-artwork_3-stripe.png"
                }
                alt="artist"
                height="auto"
                width="100%"
                onClick={() => displayModal("artist_1-artwork_3")}
                className="artminttabs_stripeimage"
              />
              {renderAmount("artist_1", "artwork_3")}
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="2">
          <Row className="g-0">
            <Col>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/ArtMintTabs/artist_2-artwork_1-stripe.png"
                }
                alt="artist"
                height="auto"
                width="100%"
                onClick={() => displayModal("artist_2-artwork_1")}
                className="artminttabs_stripeimage"
              />
              {renderAmount("artist_2", "artwork_1")}
            </Col>
            <Col>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/ArtMintTabs/artist_2-artwork_2-stripe.png"
                }
                alt="artist"
                height="auto"
                width="100%"
                onClick={() => displayModal("artist_2-artwork_2")}
                className="artminttabs_stripeimage"
              />
              {renderAmount("artist_2", "artwork_2")}
            </Col>
            <Col>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/ArtMintTabs/artist_2-artwork_3-stripe.png"
                }
                alt="artist"
                height="auto"
                width="100%"
                onClick={() => displayModal("artist_2-artwork_3")}
                className="artminttabs_stripeimage"
              />
              {renderAmount("artist_2", "artwork_3")}
            </Col>
          </Row>
        </TabPane>
        <TabPane tabId="3">
          <Row className="g-0">
            <Col>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/ArtMintTabs/artist_3-artwork_1-stripe.png"
                }
                alt="artist"
                height="auto"
                width="100%"
                onClick={() => displayModal("artist_3-artwork_1")}
                className="artminttabs_stripeimage"
              />
              {renderAmount("artist_3", "artwork_1")}
            </Col>
            <Col>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/ArtMintTabs/artist_3-artwork_2-stripe.png"
                }
                alt="artist"
                height="auto"
                width="100%"
                onClick={() => displayModal("artist_3-artwork_2")}
                className="artminttabs_stripeimage"
              />
              {renderAmount("artist_3", "artwork_2")}
            </Col>
            <Col>
              <img
                src={
                  (REACT_APP_CDN_PATH || "") +
                  "/images/ArtMintTabs/artist_3-artwork_3-stripe.png"
                }
                alt="artist"
                height="auto"
                width="100%"
                onClick={() => displayModal("artist_3-artwork_3")}
                className="artminttabs_stripeimage"
              />
              {renderAmount("artist_3", "artwork_3")}
            </Col>
          </Row>
        </TabPane>
      </TabContent>
    </Row>
  );
};

/**  define proptype for the 'translation' function  */
ArtMintTabs.contextTypes = {
  t: PropTypes.func,
};

ArtMintTabs.propTypes = {
  selectedArtist: PropTypes.string,
  setSelectedArtist: PropTypes.func,
  metaData: PropTypes.object,
};

ArtMintTabs.defaultProps = {};

export default ArtMintTabs;
